import { IPickerListItem } from "@livechat/design-system-react-components";

import { AgentDropdownItem, Item } from "components/ds-multiselect";
import { AgentPickerListItem, AgentPickerSelectedListItem } from "components/picker-items/agentPickerItems";
import { IAgent } from "store/entities/agents";

export interface IAgentFilterItem {
  id: string;
  avatar: string;
  name: string;
  email: string;
  isLoggedInAgent?: boolean;
}

export const createAgentOption = (agent: IAgent, currentAgent: IAgent): IPickerListItem => ({
  key: agent.id,
  name: agent.name + agent.email,
  customElement: {
    selectedItemBody: <AgentPickerSelectedListItem agentName={agent.name} avatarUrl={agent.avatar} />,
    listItemBody: (
      <AgentPickerListItem
        agentName={agent.name}
        avatarUrl={agent.avatar}
        isLoggedInAgent={agent.id === currentAgent.id}
        secondaryText={agent.email}
      />
    ),
  },
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getItems(agents: IAgentFilterItem[], currentAgent?: IAgent, offerUnassignment = false) {
  const items = [];

  if (offerUnassignment) {
    items.push({
      key: "",
      props: {
        id: "",
        avatarUrl: undefined,
        name: "Unassigned",
        email: null,
      },
    });
  }

  if (currentAgent) {
    items.push({
      key: currentAgent.id,
      props: {
        id: currentAgent.id,
        name: currentAgent.name,
        isLoggedInAgent: true,
        email: currentAgent.email,
        avatarUrl: currentAgent.avatar,
        searchProperty: currentAgent.email + currentAgent.name,
      },
    });
  }

  agents
    .filter(agent => !currentAgent || agent.id !== currentAgent.id)
    .forEach(agent => {
      items.push({
        key: agent.id,
        props: {
          id: agent.id,
          name: agent.name,
          email: agent.email,
          avatarUrl: agent.avatar,
          searchProperty: agent.email + agent.name,
        },
      });
    });

  return items;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getItemBody(item: IAgentFilterItem) {
  return (
    <AgentDropdownItem
      agentId={item.id}
      avatarUrl={item.avatar}
      agentName={item.name}
      agentEmail={item.email}
      isLoggedInAgent={item.isLoggedInAgent}
    />
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getSelectedItemBody(item: IAgentFilterItem) {
  return <Item className="fs-mask">{item.name}</Item>;
}
